<div matTooltip="Click here to view exchange of CbC reports" class="w-p-100 flex flex-row justify-between items-center">
  <div *ngIf="item.cells[fieldDefinition.key]?.value && item.cells[fieldDefinition.key]?.value === 'Y'"
       class="grid-cell-ellipsis m-r-5">
    Possible
  </div>
  <div *ngIf="item.cells[fieldDefinition.key]?.value && item.cells[fieldDefinition.key]?.value === 'N'"
       class="grid-cell-ellipsis m-r-5">
    No
  </div>
  <button mat-icon-button class="icon-dropdown-button" (click)="openInfo()">
    <i class="far fa-info-circle"></i>
  </button>

</div>


